import HttpClient from '../HttpService';

// recordUUID null = ACIA só com documentos (sem avaliação funcional)
function generate(recordUUID, fileUUIDs, patientUUID) {
    return HttpClient.post('/acias', {
        record_uuid: recordUUID,
        patient_uuid: patientUUID,
        file_uuids: fileUUIDs
    });
}

function listByPatient(patientUUID) {
    return HttpClient.get(`/patients/uuid/${patientUUID}/acias`);
}

function getByUUID(aciasUUID) {
    return HttpClient.get(`/acias/${aciasUUID}`);
}

function updateText(aciasUUID, textContent) {
    return HttpClient.put(`/acias/${aciasUUID}`, {
        text_content: textContent
    });
}

function exportPdf(aciasUUID) {
    return HttpClient.post(`/acias/${aciasUUID}/export-pdf`);
}

export default {
    generate,
    listByPatient,
    getByUUID,
    updateText,
    exportPdf
};
